import { useMutation } from "@tanstack/react-query";
import orbitService from "../modules/orbit-module/services/orbit-service";
import { useDispatch } from "react-redux";
import { setNotificationCount, setNotificationData } from "../feature/notification-slice";

export const useNotifyApi = () => {
    const dispatch = useDispatch();
    const { mutate: getNotify, ...mutationRest } = useMutation({
        mutationFn: orbitService.getNotification,
        onSuccess: (data) => {
          dispatch(setNotificationData(data.data.list))
          dispatch(setNotificationCount(data.data.count))
        },

        
      });

      return { getNotify, ...mutationRest };

}